export default "__VITE_ASSET__BwtBYFGB__"